import {apiClient} from "../utils/Api";

export default class ClaimService {

    static create = (data) => {
        return apiClient.post(`/claim/create`, data);
    };

    static list = () => {
        return apiClient.get('/claim/list');
    };

    static detail = (id) => {
        return apiClient.get('/claim/detail?id='+id);
    };

    static findByCarId = (car_id) => {
        return apiClient.get('/claim/detail?car_id='+car_id);
    };
}